<template>
    <div name="instance" class="instance">
        <div class="container">
            <div class="section-header">
                <strong class="title">바로돌봄 도입 사례</strong>
            </div>

            <div class="carousel-container">
                <carousel
                    :perPage="1.5"
                    :pagination-enabled="false"
                    :navigation-enabled="false"
                    :loop="false"
                    :scrollPerPage="false"
                    ref="carousel"
                >
                <slide v-for="(image, index) in images" :key="index" class="slide-img">
                    <img :src="image" alt="사례 이미지" />
                </slide>
                </carousel>
                <div class="custom-arrows">
                    <button v-if="isPrevButtonVisible" type="button" class="arrow-prev" @click="goToPrevSlide"><span class="ico ico-left">이전</span></button>
                    <button type="button" class="arrow-next" @click="goToNextSlide"><span class="ico ico-right">다음</span></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
    name: 'instance',
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
            images: [
                require('../../assets/mobile_barocare/img_reward1.png'),
                require('../../assets/mobile_barocare/img_reward2.png'),
                require('../../assets/mobile_barocare/img_reward3.png'),
                require('../../assets/mobile_barocare/img_reward4.png'),
                require('../../assets/mobile_barocare/img_reward5.png'),
                require('../../assets/mobile_barocare/img_reward6.png'),
                require('../../assets/mobile_barocare/img_reward7.png'),
                require('../../assets/mobile_barocare/img_reward8.png'),
            ],
            activeIndex: 0,
            carouselRef: null,
            isPrevButtonVisible: false,
        };
    },
    mounted() {
    this.$nextTick(() => {
        const carouselWrapper = this.$refs.carousel.$el.querySelector
                                (
                                    '.VueCarousel-wrapper'
                                );
            if (carouselWrapper) {
                carouselWrapper.style.overflow = 'visible';
            }
        });
    },
    methods: {
        goToPrevSlide() {
            const currentPage = this.$refs.carousel.currentPage;

            if (currentPage > 0) {
                const targetPage = currentPage - 1;
                this.$refs.carousel.goToPage(targetPage);
                this.isPrevButtonVisible = targetPage !== 0;
            }
        },
        goToNextSlide() {
            const currentPage = this.$refs.carousel.currentPage;
            const totalPages = this.$refs.carousel.pageCount;

            if (currentPage < totalPages - 1) {
                const targetPage = currentPage + 1;
                this.$refs.carousel.goToPage(targetPage);
            }

            this.isPrevButtonVisible = true;
        },
        onSlideChange() {
            this.isPrevButtonVisible = this.$refs.carousel.currentPage > 0;
        },
    }
}
</script>

<style scoped>
    .instance{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        background: #fff;
    }
    .instance .container{
        position: relative;
        width: 100%;
        min-height: 486px;
        margin: 0 auto;
        padding: 53px 20px 20px;
        z-index: 1;
        overflow: visible;
    }
    .section-header{
        width: 100%;
        text-align: center;
    }
    .section-header .title{
        font-family: 'Pretendard';
        font-style: normal;
        font-size: 32px;
        font-weight: 600;
        line-height: 1.4;
        color: #1A1A1A;
        text-align: center;
    }

    .carousel-container {
        position: relative;
        min-height: 190px;
        margin-top: 62px;
        overflow: visible;
    }
    /* ::v-deep .carousel-container .VueCarousel-wrapper {
    overflow: visible !important;
    } */
    .slide-img{
        min-width: 264px;
        min-height: 190px;
        margin: 0 6px;
    }
    .slide-img img{
        width: 100%;
        object-fit: contain;
    }
    .slide-img:first-child{
        margin-left: 0;
    }
    .slide-img:last-child{
        margin-right: 100px;
    }

    .custom-arrows {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        height: 100%;
    }
    .arrow-prev{
        left: 0;
        background: url(../../assets/mobile_barocare/ico-arrow-prev-md.png);
        background-position: center center;
        background-size: 32px auto;
    }
    .arrow-next{
        right: 0;
        background: url(../../assets/mobile_barocare/ico-arrow-next-md.png);
        background-position: center center;
        background-size: 32px auto;
    }
    .arrow-prev,
    .arrow-next {
        position: absolute;
        top:32%;

        width: 32px;
        height: 32px;
        text-indent: -9999px;
        cursor: pointer;
        z-index: 10;
        border: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_barocare/Instance.vue